import React, { Component } from 'react';
import axios from 'axios';
import { injectIntl, defineMessages } from 'react-intl';
import { Message, List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ModalTemplate, Loading, Button as Btn } from 'components';
import * as templateActions from 'modules/template';
import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './PhishingTemplateDeleteModal.css';
const cx = classNames.bind(styles);

class PhishingTemplateDeleteModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };
  }

  // 삭제 버튼 클릭 이벤트
  deletePhishingTemplate = async () => {
    const { loadiing } = this.state;
    const { TemplateActions, toggleModal, phishingInfo } = this.props;

    this.setState({ loading: true });
    try {
      // await axios.delete('/api/v1/Template/Phishing', {
      //   params: { phishingNo: phishingInfo.phishingNo }
      // });
      const params = {
        phishingNo: phishingInfo.phishingNo
      };
      await TemplateActions.deletePhishingTemplate(params);
    } catch (e) {
      console.log(e);
    }

    this.setState({ loading: false });
    toggleModal();
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { deletePhishingTemplate } = this;
    const { loading } = this.state;
    const { toggleModal, phishingInfo } = this.props;
    const { isBasic, phishingNo, phishingName, regEpoch } = phishingInfo;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-admin tiny', 'common-content')}
        closeIcon
        onToggleModal={toggleModal}
        visible
        header={
          <div>
            {defineMessages(formatMessage({ id: 'PhishingTemplateDeleteModal_1', defaultMessage: '피싱 페이지 삭제' }))}
          </div>
        }
        buttons={
          <div className={cx('inline-block')}>
            <Btn buttonColor="#bbbbbb" onClick={toggleModal}>
              {defineMessages(formatMessage({ id: 'PhishingTemplateDeleteModal_2', defaultMessage: '취 소' }))}
            </Btn>
            <Btn className={cx('gray-button')} loading={loading} disabled={loading} onClick={deletePhishingTemplate}>
              {defineMessages(formatMessage({ id: 'PhishingTemplateDeleteModal_3', defaultMessage: '삭 제' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={loading}
          size="small"
          content={defineMessages(formatMessage({ id: 'ExamTemplateDelete_4', defaultMessage: '삭제중...' }))}
        />
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'ExamTemplateDelete_5',
              defaultMessage: '삭제한 템플릿은 복구할 수 없습니다.'
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: 'ExamTemplateDelete_9',
              defaultMessage: '다음 템플릿을 삭제합니까?'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>
            <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>No</div>
                {isBasic ?
                  phishingNo + defineMessages(formatMessage({ id: 'ExamTemplateDelete_6', defaultMessage: '(기본 제공)' }))
                  : phishingNo}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ExamTemplateDelete_7', defaultMessage: '템플릿명' }))}
                </div>
                {phishingName}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ExamTemplateDelete_8', defaultMessage: '등록일시' }))}
                </div>
                {common.timeFormatFromUTCEpoch(regEpoch)}
              </List.Item>
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  TemplateActions: bindActionCreators(templateActions, dispatch)
});

export default connect(null, mapDispatchToProps)(injectIntl(PhishingTemplateDeleteModal));



// WEBPACK FOOTER //
// ./src/script/components/phishingTemplate/PhishingTemplateDeleteModal.js